'use es6';

export const NONE = 'NONE';
export const ADD_WIDGET_BELOW = 'ADD_WIDGET_BELOW';
export const CLONE_WIDGET = 'CLONE_WIDGET';
export const DELETE_WIDGET = 'DELETE_WIDGET';
export const EDIT_CSS = 'EDIT_CSS';
export const EDIT_CUSTOM_WIDGET = 'EDIT_CUSTOM_WIDGET';
export const EDIT_GLOBAL_GROUP = 'EDIT_GLOBAL_GROUP';
export const EDIT_GLOBAL_WIDGET = 'EDIT_GLOBAL_WIDGET';
export const EDIT_LABEL = 'EDIT_LABEL';
export const EDIT_HELP_TEXT = 'EDIT_HELP_TEXT';
export const MAKE_LOCAL_COPY_GLOBAL_WIDGET = 'MAKE_LOCAL_COPY_GLOBAL_WIDGET';
export const MAKE_LOCAL_COPY_CMV2_GLOBAL_WIDGET = 'MAKE_LOCAL_COPY_CMV2_GLOBAL_WIDGET';
export const MAKE_LOCAL_COPY_GLOBAL_GROUP = 'MAKE_LOCAL_COPY_GLOBAL_GROUP';
export const MAKE_WIDGET_GLOBAL = 'MAKE_WIDGET_GLOBAL';
export const SPLIT_HORIZONTALLY = 'SPLIT_HORIZONTALLY';
export const SWAP_WIDGET = 'SWAP_WIDGET';
export const MAKE_SMART = 'MAKE_SMART';
export const MANAGE_SMART_RULES = 'MANAGE_SMART_RULES';
export const REMOVE_SMART_RULES = 'REMOVE_SMART_RULES';
export const TOGGLE_LOCK = 'TOGGLE_LOCK';
export const GROUPING = 'GROUPING'; // For editing primary widget content/code.

export const EDIT_CONTENT = 'EDIT_CONTENT';
export const EDIT_GLOBAL_CONTENT = 'EDIT_GLOBAL_CONTENT'; // Cell specific

export const MAKE_FLEX_COLUMN = 'MAKE_FLEX_COLUMN';
export const MAKE_GROUP_GLOBAL = 'MAKE_GROUP_GLOBAL';
export const MAKE_GROUP_STATIC = 'MAKE_GROUP_STATIC';
export const UNGROUP = 'UNGROUP';
export const MAKE_GROUP_VIRTUAL = 'MAKE_GROUP_VIRTUAL';